import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, DropdownSelect, FieldText, FlexBox, Icon, IconButton, SelectItem, Text, } from '@dixa/lib-shared-habla';
import noop from 'lodash/noop';
import { useCallback, useEffect, useState } from 'react';
import styles from './authorizationHeader.module.scss';
import { authorizationItems, encodeHeader, getHeaderType, headerKey, } from './authorizationHeader.utils';
export function AuthorizationHeader({ input, }) {
    const [type, setType] = useState();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [token, setToken] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const { value, onChange } = input;
    const triggerOnChange = (value) => {
        onChange(value ? encodeHeader(value, type) : {});
    };
    const onTypeSelect = (item) => {
        if (isEditMode && item.id === type) {
            return;
        }
        setIsEditMode(true);
        setType(item.id);
        clearFields();
    };
    const onClearPreview = () => {
        setIsEditMode(false);
        setType(null);
        clearFields();
    };
    const clearFields = () => {
        setUsername('');
        setPassword('');
        setToken('');
        triggerOnChange('');
    };
    useEffect(() => {
        if (value[headerKey]) {
            setType(getHeaderType(value));
        }
    }, [value]);
    useEffect(() => {
        if (!!username.trim() && !!password.trim()) {
            triggerOnChange(`${username}:${password}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [username, password]);
    useEffect(() => {
        if (token) {
            triggerOnChange(token);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);
    const handleAuthorizationChange = useCallback((event, key) => {
        if (event) {
            const { target: { value }, } = event;
            if (key === 'username') {
                setUsername(value);
            }
            else {
                setPassword(value);
            }
        }
    }, []);
    const handleTokenChange = useCallback((event) => {
        if (event) {
            const { target: { value }, } = event;
            setToken(value);
        }
    }, []);
    const renderContent = () => {
        var _a;
        if (!type) {
            return null;
        }
        const authorizationName = (_a = authorizationItems.find((item) => item.id === type)) === null || _a === void 0 ? void 0 : _a.name;
        if (isEditMode) {
            return (_jsx(FlexBox, Object.assign({ className: styles.content, flexDirection: "row" }, { children: type === 'basic' ? (_jsxs(_Fragment, { children: [_jsx(FieldText, { className: styles.control, label: "Username", input: {
                                name: 'username',
                                value: username !== null && username !== void 0 ? username : '',
                                onChange: (event) => handleAuthorizationChange(event, 'username'),
                            }, placeholder: "Type username" }), _jsx(FieldText, { className: styles.control, label: "Password", input: {
                                name: 'password',
                                value: password !== null && password !== void 0 ? password : '',
                                onChange: (event) => handleAuthorizationChange(event, 'password'),
                            }, type: "password", placeholder: "Type password" })] })) : (_jsx(FieldText, { className: styles.control, label: "Token", input: {
                        name: 'token',
                        value: token !== null && token !== void 0 ? token : '',
                        onChange: handleTokenChange,
                    }, placeholder: "Type token" })) })));
        }
        return (_jsxs(FlexBox, Object.assign({ className: styles.content, flexDirection: "row" }, { children: [_jsx(FieldText, { className: styles.control, label: `${authorizationName} header`, disabled: true, input: {
                        name: headerKey,
                        value: input.value[headerKey] || '',
                        onChange: noop,
                    } }), _jsx(IconButton, { icon: "trash", variant: "tertiary", className: styles.button, onClick: onClearPreview })] })));
    };
    return (_jsxs(Box, Object.assign({ className: styles.root }, { children: [_jsxs(FlexBox, Object.assign({ className: styles.header, flexDirection: "row", justifyContent: "space-between", alignItems: "center" }, { children: [_jsx(Text.Heading, Object.assign({ variant: "heading-3" }, { children: "Authorization" })), _jsx(DropdownSelect, Object.assign({ items: authorizationItems, itemComponent: SelectItem, buttonProps: {
                            variant: 'tertiary',
                        }, onSelect: onTypeSelect }, { children: type ? _jsx(Icon, { name: "pen" }) : _jsx(Icon, { name: "plus" }) }))] })), renderContent()] })));
}
